import { MessageCircleQuestion } from "@dreamhub/designsystem/icons";
import { Button } from "@/components/ui/button";
import { useChat } from "@/components/layouts/Chat/ChatContext";
import { useSuggestedQuestions } from "@/entities/messaging/hooks";
import Text from "@/components/ui/text";
import IconContainer from "@/components/ui/icon-container";

const MAX_QUESTIONS = 3;
const MAX_ROWS = 1;
const QUESTIONS_PER_ROW = MAX_QUESTIONS / MAX_ROWS;

interface HeaderQuestionsProps {
  sendQuestionDirectly: (questionText: string) => void;
}

interface HeaderQuestionButtonProps {
  questionText: string;
}

const HeroHeaderQuestionButton: React.FC<
  HeaderQuestionButtonProps & HeaderQuestionsProps
> = ({ questionText, sendQuestionDirectly }) => {
  const { waitingForMessage } = useChat();
  return (
    <Button
      variant="secondary"
      className="px-4 py-[10px] min-w-44 w-full justify-start min-h-11 h-full rounded-[40px] border !border-white-8 !bg-transparent hover:!bg-surface-hover-soft active:!bg-surface-pressed backdrop-blur-[12px] whitespace-break-spaces text-start"
      onClick={() => sendQuestionDirectly(questionText)}
      disabled={waitingForMessage}
    >
      <div className="flex flex-row h-full w-full justify-start items-center gap-3">
        <IconContainer size="5" color="secondary">
          <MessageCircleQuestion />
        </IconContainer>
        <Text>{questionText}</Text>
      </div>
    </Button>
  );
};

export const HeroHeaderQuestions = (props: HeaderQuestionsProps) => {
  const { data: suggestedQuestions, isSuccess } = useSuggestedQuestions();

  const questions = isSuccess
    ? suggestedQuestions?.slice(0, MAX_QUESTIONS) || []
    : Array(MAX_QUESTIONS).fill("");

  const rows = [...Array(MAX_ROWS)].map((_, rowIndex) =>
    questions.slice(
      rowIndex * QUESTIONS_PER_ROW,
      (rowIndex + 1) * QUESTIONS_PER_ROW
    )
  );

  return (
    <div className="grid grid-cols-3 gap-x-4 gap-y-2 w-full">
      {rows.map((row, rowIndex) =>
        row
          .map((question, colIndex) => (
            <div
              key={`question-${rowIndex}-${colIndex}`}
              className="row-start-auto"
            >
              <HeroHeaderQuestionButton questionText={question} {...props} />
            </div>
          ))
          .concat(
            [...Array(QUESTIONS_PER_ROW - row.length)].map((_, index) => (
              <div key={`empty-${rowIndex}-${index}`} />
            ))
          )
      )}
    </div>
  );
};
